import React from 'react';
import { View, Pressable } from 'react-native';
import PropTypes from 'prop-types';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useTheme } from '@/context/ThemeContext';
import { reportWorkLaunchError } from '@/lib/reportWorkLaunchError';

export default function WorkLaunchWaitNotice({ waiting }) {
  const { colors } = useTheme();
  if (!waiting) return null;
  return <View testID="work-launch-wait" accessibilityLiveRegion="polite" accessible
    accessibilityLabel={`${waiting.text}. ${waiting.detail} You can stop this request at any time.`}
    style={{ margin: 8, padding: 14, borderRadius: 12, backgroundColor: colors.solid_color_secondary,
      flexDirection: 'row', alignItems: 'flex-start', gap: 10 }}>
    <Icon name={waiting.icon} size={14} color={colors.text_color_secondary} />
    <View style={{ flex: 1, gap: 4 }}>
      <Text size="s" weight="semibold">{waiting.text}</Text>
      <Text size="xs" color="secondary">{waiting.detail}</Text>
      {waiting.icon === 'coins' && <Pressable accessibilityRole="button" accessibilityLabel="Add credits"
        onPress={() => reportWorkLaunchError({ status: 402 }, { source: 'launch_wait' })} style={{ alignSelf: 'flex-start', paddingVertical: 4 }}>
        <Text size="xs" weight="semibold">Add credits</Text>
      </Pressable>}
      <Text size="xs" color="secondary">You can stop this request at any time.</Text>
    </View>
  </View>;
}
WorkLaunchWaitNotice.propTypes = { waiting: PropTypes.shape({ text: PropTypes.string, detail: PropTypes.string, icon: PropTypes.string }) };
